// ======================================= ******* =========================================
/**
 *  ==============================
 *  ==============================
 *  ============================== DJANGO BACKEND API ENDPOINTS START ==============================
 *  ==============================
 *  ==============================
 */

/**
 * External API Endpoints (Outside Next.js)
 */

const API_PREFIX_CASHLESS_ADMIN =
  process.env.NEXT_PUBLIC_API_PREFIX_CASHLESS_ADMIN;
const API_PREFIX_CASHLESS_TENANTS =
  process.env.NEXT_PUBLIC_API_PREFIX_CASHLESS_TENANTS;
const API_PREFIX_EVENT_MANAGEMENT =
  process.env.NEXT_PUBLIC_API_PREFIX_EVENT_MANAGEMENT;
const API_PREFIX_STAFF_MANAGEMENT =
  process.env.NEXT_PUBLIC_API_PREFIX_STAFF_MANAGEMENT;
const API_PREFIX_INVENTORY_MANAGEMENT =
  process.env.NEXT_PUBLIC_API_PREFIX_INVENTORY_MANAGEMENT;
const API_PREFIX_ANALYTICS = process.env.NEXT_PUBLIC_API_PREFIX_ANALYTICS;
const API_PREFIX_HUB = process.env.NEXT_PUBLIC_API_PREFIX_CASHLESS_TENANTS;

const AUTH_ROOT = `${API_PREFIX_CASHLESS_ADMIN}/auth/v1`;

export const EXTERNAL_API_ENDPOINTS = {
  // LOGIN: "auth/v1/login/",
  LOGIN: `${AUTH_ROOT}/login/`,
  // Add other external endpoints here as needed
} as const;

// =====================PROFILE===========================
const PROFILE_ROOT = `${API_PREFIX_STAFF_MANAGEMENT}/staff/v1`;

export const PROFILE_API_ENDPOINTS = {
  GET_USER_PROFILE: `${PROFILE_ROOT}/staff/`,
  UPDATE_USER_PROFILE: `${PROFILE_ROOT}/staff/`,
} as const;

// ======================TENANTS MANAGEMENT=======================
const TENANTS_ROOT = `${API_PREFIX_CASHLESS_TENANTS}/v1`;

export const TENANTS_API_ENDPOINTS = {
  GET_TENANTS: `${TENANTS_ROOT}/tenants/`,
  GET_TENANT_DETAILS: `${TENANTS_ROOT}/tenants/`, // For individual tenant by ID
  CREATE_TENANT: `${TENANTS_ROOT}/onboarding/create-tenant/`,
  UPDATE_TENANT: `${TENANTS_ROOT}/tenants/`,
  EDIT_BUSINESS: `${TENANTS_ROOT}/tenants/`,
  DELETE_TENANT: `${TENANTS_ROOT}/tenants/`,
  SUSPEND_TENANT: `${TENANTS_ROOT}/tenants/`,
  ACTIVATE_TENANT: `${TENANTS_ROOT}/tenants/`,
  DEACTIVATE_TENANT: `${TENANTS_ROOT}/tenants/`,
  DELETE_DOMAIN: `${TENANTS_ROOT}/tenants/`,
  ADD_DOMAIN: `${TENANTS_ROOT}/tenants/`,
  TENANT_STATS: `${TENANTS_ROOT}/tenants/stats/`,
  // Caddy-backed: list all registered domains (used for CSRF allowlist refresh)
  LIST_REGISTERED_DOMAINS: `${TENANTS_ROOT}/domains/`,
  // Caddy-backed: check if a single domain is registered (used by ask endpoint)
  CHECK_REGISTERED_DOMAIN: `${TENANTS_ROOT}/domains/check/`,
} as const;

// ======================BUSINESS APPLICATIONS=======================
export const APPLICATIONS_API_ENDPOINTS = {
  APPLICATIONS: `${TENANTS_ROOT}/applications/`,
  APPLICATION_DETAIL: (id: string) => `${TENANTS_ROOT}/applications/${id}/`,
  APPLICATION_STATS: `${TENANTS_ROOT}/applications/stats/`,
  APPLICATION_APPROVE: (id: string) =>
    `${TENANTS_ROOT}/applications/${id}/approve/`,
  APPLICATION_REJECT: (id: string) =>
    `${TENANTS_ROOT}/applications/${id}/reject/`,
  APPLICATION_REQUEST_INFO: (id: string) =>
    `${TENANTS_ROOT}/applications/${id}/request_info/`,
  APPLICATION_PROVISION: (id: string) =>
    `${TENANTS_ROOT}/applications/${id}/provision/`,
  APPLICATION_SUBMIT: (id: string) =>
    `${TENANTS_ROOT}/applications/${id}/submit/`,
  DOCUMENTS: `${TENANTS_ROOT}/documents/`,
  NOTES: `${TENANTS_ROOT}/notes/`,
} as const;

// ======================STAFF MANAGEMENT=======================
const STAFF_MANAGEMENT_ROOT = `${API_PREFIX_STAFF_MANAGEMENT}/staff/v1`;
const SETTINGS_ROOT = `${API_PREFIX_STAFF_MANAGEMENT}/settings/v1`;

export const STAFF_MANAGEMENT_API_ENDPOINTS = {
  // Add staff management endpoints here
  GET_ALL_STAFF_MEMBERS: `${STAFF_MANAGEMENT_ROOT}/staff/`,
  GET_STAFF_MEMBER_NAMES: `${STAFF_MANAGEMENT_ROOT}/staff/minimal/`,
  CREATE_STAFF_MEMBER: `${STAFF_MANAGEMENT_ROOT}/staff/`,
  UPDATE_STAFF_MEMBER: `${STAFF_MANAGEMENT_ROOT}/staff/`,
  DELETE_STAFF_MEMBER: `${STAFF_MANAGEMENT_ROOT}/staff/`,
  // staff salary
  GET_STAFF_SALARY: `${STAFF_MANAGEMENT_ROOT}/salaries/`,
  CREATE_STAFF_SALARY: `${STAFF_MANAGEMENT_ROOT}/salaries/`,
  UPDATE_STAFF_SALARY: `${STAFF_MANAGEMENT_ROOT}/salaries/`,
  DELETE_STAFF_SALARY: `${STAFF_MANAGEMENT_ROOT}/salaries/`,
  // staff bonus
  GET_STAFF_BONUS: `${STAFF_MANAGEMENT_ROOT}/bonuses/`,
  CREATE_STAFF_BONUS: `${STAFF_MANAGEMENT_ROOT}/bonuses/`,
  UPDATE_STAFF_BONUS: `${STAFF_MANAGEMENT_ROOT}/bonuses/`,
  DELETE_STAFF_BONUS: `${STAFF_MANAGEMENT_ROOT}/bonuses/`,
} as const;

// ======================AI AGENT=======================
const AI_AGENT_ROOT = `${API_PREFIX_CASHLESS_TENANTS}/admin/agent`;

export const AI_AGENT_API_ENDPOINTS = {
  GET_MODELS: `${AI_AGENT_ROOT}/models/`,
  GET_ACTIVE_MODEL: `${AI_AGENT_ROOT}/model/`,
} as const;

// ======================SETTINGS=======================
export const SETTINGS_API_ENDPOINTS = {
  // email credentials
  GET_EMAIL_CREDENTIALS: `${SETTINGS_ROOT}/system-email-config/`,
  CREATE_EMAIL_CREDENTIAL: `${SETTINGS_ROOT}/system-email-config/`,
  // Note: These are functions that accept ID parameter for Django URL construction
  // Django requires ID in URL path: /system-email-config/{id}/
  UPDATE_EMAIL_CREDENTIAL: (id: string) =>
    `${SETTINGS_ROOT}/system-email-config/${id}/`,
  DELETE_EMAIL_CREDENTIAL: (id: string) =>
    `${SETTINGS_ROOT}/system-email-config/${id}/`,
  TEST_EMAIL_CREDENTIAL: (id: string) =>
    `${SETTINGS_ROOT}/system-email-config/${id}/test/`,
  ACTIVATE_EMAIL_CREDENTIAL: (id: string) =>
    `${SETTINGS_ROOT}/system-email-config/${id}/activate/`,
} as const;

// ==============================HUB ADMIN========================
const HUB_ROOT = `${API_PREFIX_HUB}/v1`;

export const HUB_API_ENDPOINTS = {
  PRODUCTS: `${HUB_ROOT}/products/`,
  PRODUCT_DETAIL: (productId: string) => `${HUB_ROOT}/products/${productId}/`,
  PRODUCT_SUPPLIERS: (productId: string) =>
    `${HUB_ROOT}/products/${productId}/suppliers/`,
  PRODUCT_CATALOG_STATS: `${HUB_ROOT}/products/stats/`,
  PRODUCT_REQUESTS: `${HUB_ROOT}/product-requests/`,
  PRODUCT_REQUEST_DETAIL: (requestId: string) =>
    `${HUB_ROOT}/product-requests/${requestId}/`,
  PRODUCT_REQUESTS_STATS: `${HUB_ROOT}/product-requests/stats/`,
  CATEGORIES: `${HUB_ROOT}/categories/`,
} as const;

// ==============================PRODUCT MANAGEMENT========================
const PRODUCT_MANAGEMENT_ROOT = `${API_PREFIX_INVENTORY_MANAGEMENT}/suppliers/admin/v1`;

export const PRODUCT_MANAGEMENT_API_ENDPOINTS = {
  // central products
  GET_CENTRAL_PRODUCTS: `${PRODUCT_MANAGEMENT_ROOT}/central-catalog/`,
  CREATE_CENTRAL_PRODUCT: `${PRODUCT_MANAGEMENT_ROOT}/central-catalog/`,
  UPDATE_CENTRAL_PRODUCT: `${PRODUCT_MANAGEMENT_ROOT}/central-catalog/`,
  DELETE_CENTRAL_PRODUCT: `${PRODUCT_MANAGEMENT_ROOT}/central-catalog/`,

  // product categories
  GET_PRODUCT_CATEGORIES: `${PRODUCT_MANAGEMENT_ROOT}/categories/`,
  CREATE_PRODUCT_CATEGORY: `${PRODUCT_MANAGEMENT_ROOT}/categories/`,
  UPDATE_PRODUCT_CATEGORY: `${PRODUCT_MANAGEMENT_ROOT}/categories/`,
  DELETE_PRODUCT_CATEGORY: `${PRODUCT_MANAGEMENT_ROOT}/categories/`,

  // product requests
  GET_REQUEST_PRODUCTS: `${PRODUCT_MANAGEMENT_ROOT}/product-requests/`,
  APPROVE_REQUEST_PRODUCT: `${PRODUCT_MANAGEMENT_ROOT}/product-requests/`,
  REJECT_REQUEST_PRODUCT: `${PRODUCT_MANAGEMENT_ROOT}/product-requests/`,

  // supplier products
  GET_SUPPLIER_PRODUCTS: `${PRODUCT_MANAGEMENT_ROOT}/supplier-products/?is_available=true`,

  // assignments
  CREATE_ASSIGNMENT: `${PRODUCT_MANAGEMENT_ROOT}/assignments/`,
  DELETE_ASSIGNMENT: `${PRODUCT_MANAGEMENT_ROOT}/assignments/`,
  GET_RESTAURANT_ASSIGNMENTS: `${PRODUCT_MANAGEMENT_ROOT}/assignments/by-restaurant`,
  GET_SUPPLIER_ASSIGNMENTS: `${PRODUCT_MANAGEMENT_ROOT}/assignments/by-supplier`,

  // supplier directory
  SUPPLIER_DIRECTORY: `${API_PREFIX_INVENTORY_MANAGEMENT}/suppliers/v1/directory/`,
} as const;

// =================== EXTERNAL API ENDPOINTS ===================
//auth-related
export const LOGIN_ENDPOINT_OUTSIDE = EXTERNAL_API_ENDPOINTS.LOGIN;

//profile-related
export const GET_USER_PROFILE_ENDPOINT_OUTSIDE =
  PROFILE_API_ENDPOINTS.GET_USER_PROFILE;
export const UPDATE_USER_PROFILE_ENDPOINT_OUTSIDE =
  PROFILE_API_ENDPOINTS.UPDATE_USER_PROFILE;

// cashless-related
export const TENANTS_ENDPOINT_OUTSIDE = TENANTS_API_ENDPOINTS.GET_TENANTS;
export const LIST_REGISTERED_DOMAINS_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.LIST_REGISTERED_DOMAINS;
export const CHECK_REGISTERED_DOMAIN_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.CHECK_REGISTERED_DOMAIN;
export const TENANT_DETAILS_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.GET_TENANT_DETAILS;
export const CREATE_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.CREATE_TENANT;
export const UPDATE_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.UPDATE_TENANT;
export const EDIT_BUSINESS_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.EDIT_BUSINESS;
export const DELETE_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.DELETE_TENANT;
export const SUSPEND_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.SUSPEND_TENANT;
export const ACTIVATE_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.ACTIVATE_TENANT;
export const DEACTIVATE_TENANT_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.DEACTIVATE_TENANT;
export const DELETE_DOMAIN_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.DELETE_DOMAIN;
export const ADD_DOMAIN_ENDPOINT_OUTSIDE =
  TENANTS_API_ENDPOINTS.ADD_DOMAIN;

//staff-management-related
export const STAFF_MEMBERS_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.GET_ALL_STAFF_MEMBERS;
export const STAFF_MEMBER_NAMES_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.GET_STAFF_MEMBER_NAMES;
export const CREATE_STAFF_MEMBER_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.CREATE_STAFF_MEMBER;
export const UPDATE_STAFF_MEMBER_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.UPDATE_STAFF_MEMBER;
export const DELETE_STAFF_MEMBER_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.DELETE_STAFF_MEMBER;

// staff-salary-related
export const STAFF_SALARY_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.GET_STAFF_SALARY;
export const CREATE_STAFF_SALARY_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.CREATE_STAFF_SALARY;
export const UPDATE_STAFF_SALARY_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.UPDATE_STAFF_SALARY;
export const DELETE_STAFF_SALARY_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.DELETE_STAFF_SALARY;

// staff-bonus-related
export const STAFF_BONUS_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.GET_STAFF_BONUS;
export const CREATE_STAFF_BONUS_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.CREATE_STAFF_BONUS;
export const UPDATE_STAFF_BONUS_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.UPDATE_STAFF_BONUS;
export const DELETE_STAFF_BONUS_ENDPOINT_OUTSIDE =
  STAFF_MANAGEMENT_API_ENDPOINTS.DELETE_STAFF_BONUS;

// hub-admin-related
export const HUB_PRODUCTS_ENDPOINT_OUTSIDE = HUB_API_ENDPOINTS.PRODUCTS;
export const HUB_PRODUCT_DETAIL_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_DETAIL;
export const HUB_PRODUCT_SUPPLIERS_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_SUPPLIERS;
export const HUB_PRODUCT_REQUESTS_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_REQUESTS;
export const HUB_PRODUCT_REQUEST_DETAIL_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_REQUEST_DETAIL;
export const HUB_PRODUCT_REQUESTS_STATS_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_REQUESTS_STATS;
export const PRODUCT_CATALOG_STATS_ENDPOINT_OUTSIDE =
  HUB_API_ENDPOINTS.PRODUCT_CATALOG_STATS;
export const HUB_CATEGORIES_ENDPOINT_OUTSIDE = HUB_API_ENDPOINTS.CATEGORIES;

// product-categories-related
export const CENTRAL_PRODUCTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_CENTRAL_PRODUCTS;
export const CREATE_CENTRAL_PRODUCT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.CREATE_CENTRAL_PRODUCT;
export const UPDATE_CENTRAL_PRODUCT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.UPDATE_CENTRAL_PRODUCT;
export const DELETE_CENTRAL_PRODUCT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.DELETE_CENTRAL_PRODUCT;

export const PRODUCT_CATEGORIES_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_PRODUCT_CATEGORIES;
export const CREATE_PRODUCT_CATEGORY_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.CREATE_PRODUCT_CATEGORY;
export const UPDATE_PRODUCT_CATEGORY_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.UPDATE_PRODUCT_CATEGORY;
export const DELETE_PRODUCT_CATEGORY_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.DELETE_PRODUCT_CATEGORY;

export const REQUEST_PRODUCTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_REQUEST_PRODUCTS;
export const GET_REQUEST_PRODUCTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_REQUEST_PRODUCTS;
export const APPROVE_REQUEST_PRODUCT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.APPROVE_REQUEST_PRODUCT;
export const REJECT_REQUEST_PRODUCT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.REJECT_REQUEST_PRODUCT;

export const SUPPLIER_PRODUCTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_SUPPLIER_PRODUCTS;
export const GET_SUPPLIER_PRODUCTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_SUPPLIER_PRODUCTS;

//assignment-related
export const CREATE_ASSIGNMENT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.CREATE_ASSIGNMENT;
export const GET_RESTAURANT_ASSIGNMENTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_RESTAURANT_ASSIGNMENTS;
export const GET_SUPPLIER_ASSIGNMENTS_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.GET_SUPPLIER_ASSIGNMENTS;
export const DELETE_ASSIGNMENT_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.DELETE_ASSIGNMENT;
export const SUPPLIER_DIRECTORY_ENDPOINT_OUTSIDE =
  PRODUCT_MANAGEMENT_API_ENDPOINTS.SUPPLIER_DIRECTORY;

// business-applications-related
export const APPLICATIONS_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATIONS;
export const APPLICATION_DETAIL_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_DETAIL;
export const APPLICATION_STATS_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_STATS;
export const APPLICATION_APPROVE_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_APPROVE;
export const APPLICATION_REJECT_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_REJECT;
export const APPLICATION_REQUEST_INFO_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_REQUEST_INFO;
export const APPLICATION_PROVISION_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_PROVISION;
export const APPLICATION_SUBMIT_ENDPOINT_OUTSIDE =
  APPLICATIONS_API_ENDPOINTS.APPLICATION_SUBMIT;
export const DOCUMENTS_ENDPOINT_OUTSIDE = APPLICATIONS_API_ENDPOINTS.DOCUMENTS;
export const NOTES_ENDPOINT_OUTSIDE = APPLICATIONS_API_ENDPOINTS.NOTES;

// tenant-stats-related
export const TENANT_STATS_ENDPOINT_OUTSIDE = TENANTS_API_ENDPOINTS.TENANT_STATS;

// ======================ANALYTICS (PLATFORM DASHBOARD)=======================
const ANALYTICS_ROOT = `${API_PREFIX_ANALYTICS}/platform/v1`;

export const ANALYTICS_API_ENDPOINTS = {
  DASHBOARD_OVERVIEW: `${ANALYTICS_ROOT}/dashboard/overview/`,
  SERVICES_HEALTH: `${ANALYTICS_ROOT}/dashboard/services-health/`,
} as const;

// analytics-related (platform dashboard)
export const DASHBOARD_OVERVIEW_ENDPOINT_OUTSIDE =
  ANALYTICS_API_ENDPOINTS.DASHBOARD_OVERVIEW;
export const SERVICES_HEALTH_ENDPOINT_OUTSIDE =
  ANALYTICS_API_ENDPOINTS.SERVICES_HEALTH;

// ai-agent-related
export const AI_MODELS_ENDPOINT_OUTSIDE = AI_AGENT_API_ENDPOINTS.GET_MODELS;
export const ACTIVE_AI_MODEL_ENDPOINT_OUTSIDE =
  AI_AGENT_API_ENDPOINTS.GET_ACTIVE_MODEL;

// settings-related (email credentials)
export const EMAIL_CREDENTIALS_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.GET_EMAIL_CREDENTIALS;
export const CREATE_EMAIL_CREDENTIAL_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.CREATE_EMAIL_CREDENTIAL;
export const UPDATE_EMAIL_CREDENTIAL_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.UPDATE_EMAIL_CREDENTIAL;
export const DELETE_EMAIL_CREDENTIAL_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.DELETE_EMAIL_CREDENTIAL;
export const TEST_EMAIL_CREDENTIAL_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.TEST_EMAIL_CREDENTIAL;
export const ACTIVATE_EMAIL_CREDENTIAL_ENDPOINT_OUTSIDE =
  SETTINGS_API_ENDPOINTS.ACTIVATE_EMAIL_CREDENTIAL;

/** *  ==============================
 *  ==============================
 *  ============================== DJANGO BACKEND API ENDPOINTS END ==============================
 *  ==============================
 *  ==============================
 */
